export const STATUS_AVAILABLE = 'depot_permissions_card_status_available'
export const STATUS_EXPIRED = 'depot_permissions_card_status_expired'
export const STATUS_LOST = 'depot_permissions_card_status_lost'
export const STATUS_NA = 'depot_permissions_card_status_na'
export const STATUS_STOLEN = 'depot_permissions_card_status_stolen'
export const STATUS_UNAVAILABLE = 'depot_permissions_card_status_unavailable'
export const STATUS_UNKNOWN = 'depot_permissions_card_status_unknown'
